<template>
    <b-modal
        :id="modalUUid"
        :ref="modalUUid"
        title="Activate User"
        :hide-footer="true"
    >
        <BaseForm
            ref="main_form"
            :settings="activateFormSettings"
            @success="successAddedUserBan"
            @cancel="$bvModal.hide(modalUUid)"
            v-slot="{ save, cancel }"
        >
            <b-alert :show="isNeedApproval" variant="warning" class="p-1">
              <b-icon icon="exclamation-circle" variant="warning" class="mr-50"></b-icon>
              <b class="text-warning">You need an approval for this action</b>
            </b-alert>

            <b-row class="mb-1" style="display: flex; align-items: center">
                <b-col cols="12 mb-1"> Protect from automatic Status changes for: </b-col>
              <template v-if="showBothFields">
                <b-col cols="12">
                  <div style="display: flex; gap: 20px;">
                    <div style="width: 60px; padding-top: 2px;">For</div>
                    <FormElement
                      ref="protected_completes"
                      style="margin-bottom: 0px;"
                      :elementSettings="activateFormSettings.formElements.protected_completes"
                      :formSettings="activateFormSettings"
                    />
                    <div class="d-inline-flex ml-auto align-items-center" style="gap: 10px;">
                      <a class="text-primary" @click.prevent="applyPercentage('protected_completes', 50)">50 %</a>
                      <a class="text-primary" @click.prevent="applyPercentage('protected_completes', 100)">100 %</a>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12" class="mt-1">
                  <div style="display: flex; gap: 20px;">
                    <div style="width: 60px; padding-top: 2px;">For</div>
                    <FormElement
                      ref="protected_offers_payout"
                      style="margin-bottom: 0px;"
                      :elementSettings="activateFormSettings.formElements.protected_offers_payout"
                      :formSettings="activateFormSettings"
                      @focusout.native="handleFocusout"
                    />
                    <div class="d-inline-flex ml-auto align-items-center" style="gap: 10px;">
                      <a class="text-primary" @click.prevent="applyPercentage('protected_offers_payout', 50)">50 %</a>
                      <a class="text-primary" @click.prevent="applyPercentage('protected_offers_payout', 100)">100 %</a>
                    </div>
                  </div>
                </b-col>
              </template>

              <!-- Show Only One Field Based on Comment -->
              <b-col cols="12" v-else>
                <div style="display: flex;gap: 20px;">
                  <div style="width: 60px; padding-top: 2px;">For</div>
                  <div v-if="showOffersPayout">
                    <FormElement
                      ref="protected_offers_payout"
                      style="margin-bottom: 0px;"
                      :elementSettings="activateFormSettings.formElements.protected_offers_payout"
                      :formSettings="activateFormSettings"
                      @focusout.native="handleFocusout"
                    />
                  </div>

                  <div v-else>
                    <FormElement
                      ref="protected_completes"
                      style="margin-bottom: 0px;"
                      :elementSettings="activateFormSettings.formElements.protected_completes"
                      :formSettings="activateFormSettings"
                    />
                  </div>

                  <div class="d-inline-flex ml-auto align-items-center" style="gap: 10px;">
                    <a
                      class="text-primary"
                      @click.prevent="applyPercentage(showOffersPayout ? 'protected_offers_payout' : 'protected_completes', 50)"
                    >50 %</a>
                    <a
                      class="text-primary"
                      @click.prevent="applyPercentage(showOffersPayout ? 'protected_offers_payout' : 'protected_completes', 100)"
                    >100 %</a>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-1">
                <b-col cols="2"> Internal Comment </b-col>
                <b-col cols="10">
                    <FormElement
                        ref="comment"
                        :elementSettings="activateFormSettings.formElements.comment"
                        :formSettings="activateFormSettings"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="primary" @click="save" class="mr-1">
                        Save
                    </b-button>
                    <b-button variant="warning" @click="cancel()"
                        >Cancel</b-button
                    >
                </b-col>
            </b-row>
        </BaseForm>
    </b-modal>
</template>

<script>
export default {
  props:{
    userId: {
      required: true
    },
    isNeedApproval: {
      type: Boolean,
      default: false
    },
    status: {
      required: true
    },
    completesCount: {
      type: Number,
      required: true,
      validator: value => Number.isInteger(value)
    },
    payoutOffersTotal: {
      type: Number,
      default: null,
      required: false
    },
    comment: {
      type: String,
      default: null,
      required: false
    }
  },
  data () {
    const isTestMode = this.isTestMode()
    const vueInstance = this
    return {
      modalUUid: `protected-user-modal${ this.userId }`,
      refreshKey: 'protected-user-modal',
      showBothFieldsErrorMessage: 'At least one of the fields is required!',
      protectedCompletesErrorMessage: 'Completes field is required!',
      protectedOffersPayoutErrorMessage: 'Publisher Payout Sum field is required!',
      activateFormSettings: {
        addUrl: `/api/users/${  this.userId  }/status`,
        method: 'PUT',
        http: this.$httpSupport,
        primaryKey: 'id',
        formElements: {
          protected_completes: {
            type: 'input',
            sub_type: 'number',
            defaultValue: null,
            value: null,
            errorClass: 'input-error',
            isValidated: false,
            isError: false,
            refreshKey: 'protected_completes',
            controlStyle: 'width: 200px;',
            post_param: 'protected_completes',
            place_holder: 'Number of completes',
            next_text: 'completes',
            min: 1,
            max: 16777215,
            step: 1,
            validate (elementSettings, formSettings) {
              if (vueInstance.showBothFields)  return true
              if (vueInstance.showOffersPayout) return true

              const value = parseInt(formSettings.formElements.protected_completes?.value)
              
              if (isNaN(value) || value <= 0) {
                return isTestMode || false
              }
              
              if (value < 1 || value > 16777215) {
                return false
              }

              return isTestMode || value > 0
            },
            get errorMessage () {
              const value = parseInt(vueInstance.activateFormSettings.formElements.protected_completes?.value)
              
              if (isNaN(value) || value <= 0) {
                return vueInstance.getCompletesErrorMessage()
              }
              
              if (value < 1) {
                return 'Minimum value is 1'
              }
              
              if (value > 16777215) {
                return 'Maximum value is 16,777,215'
              }
              
              return vueInstance.getCompletesErrorMessage()
            }
          },
          protected_offers_payout: {
            type: 'input',
            sub_type: 'number',
            defaultValue: null,
            value: null,
            errorClass: 'input-error',
            isValidated: false,
            isError: false,
            refreshKey: 'protected_offers_payout',
            controlStyle: 'width: 200px;',
            post_param: 'protected_offers_payout',
            place_holder: 'Publisher Payout Sum',
            next_text: '$ offer payout',
            validate (elementSettings, formSettings) {
              if (vueInstance.showBothFields) {
                return vueInstance.atLeastOneFieldFilled()
              }

              if (!vueInstance.showOffersPayout) return true

              return isTestMode || parseFloat(formSettings.formElements.protected_offers_payout?.value) > 0
            },
            get errorMessage () {
              return vueInstance.getOffersPayoutErrorMessage()
            }
          },
          comment: {
            type: 'textarea',
            defaultValue: '',
            post_param: 'comment',
            value: '',
            errorClass: 'input-error',
            errorMessage: 'Internal comment is required!',
            isValidated: false,
            place_holder: 'Input internal comment',
            isError: false,
            maxlength: 255,
            refreshKey: 'comment'
          },
          status: {
            type: 'hidden',
            sub_type: 'hidden',
            defaultValue: 1,
            post_param: 'status',
            rules: ['required'],
            value: 1
          }
        },
        vueContainer: this
      }
    }
  },
  computed: {
    showOffersPayout () {
      return this.comment && /offer|reward/i.test(this.comment)
    },
    showBothFields () {
      return [2, 3, 6].includes(this.status) || /\(payout\)/i.test(this.comment)
    }
  },
  watch: {
    watch: {
      comment: {
        immediate: true,
        handler (newValue) {
          if (this.showBothFields) return
          if (this.showOffersPayout) {
            this.activateFormSettings.formElements.protected_completes.value = null
          } else {
            this.activateFormSettings.formElements.protected_offers_payout.value = null
          }
        }
      }
    }
  },
  methods: {
    showForm () {
      this.$bvModal.show(this.modalUUid)

      this.$nextTick(() => {
        this.getFormVue().clearForm()
      })
    },
    atLeastOneFieldFilled () {
      return (
        parseFloat(this.activateFormSettings.formElements.protected_offers_payout?.value || 0) > 0 ||
        parseInt(this.activateFormSettings.formElements.protected_completes?.value || 0) > 0
      )
    },
    getCompletesErrorMessage () {
      return this.showBothFields ? '' : 'Completes field is required!'
    },
    getOffersPayoutErrorMessage () {
      return this.showBothFields ? 'At least one of the fields is required!' : 'Publisher Payout Sum field is required!'
    },
    async successAddedUserBan (data) {
      this.$emit('activated', data.response)
      this.$bvModal.hide(this.modalUUid)

      if ('/support-user-reviews' === this.$route.path) {
        return;
      }

      this.showLoading()
      try {
        const response = await this.$http.get(`/api/user/${data.response.id}`);
        this.$emit('update:user', response.data.user);
      } catch (error) {
        // Do nothing on error
      } finally {
        this.hideLoading();
      }
    },
    getFormVue () {
      return this.$refs.main_form
    },
    handleFocusout () {
      const val = this.activateFormSettings.formElements.protected_offers_payout.value
      if (val !== null && val !== '' && !isNaN(val)) {
        this.activateFormSettings.formElements.protected_offers_payout.value = parseFloat(val).toFixed(2)
      }
    },
    applyPercentage (field, percentage) {
      let baseValue = 0

      if (field === 'protected_completes') {
        baseValue = this.completesCount || 0
      } else if (field === 'protected_offers_payout') {
        baseValue = this.payoutOffersTotal || 0
      }

      const rawValue = (baseValue * (percentage / 100))

      this.activateFormSettings.formElements[field].value = Math.round(rawValue)
    }
  }
}
</script>

<style>
</style>
